<template>
  <div class="modal-mask" v-if="show" @click.self="close">
    <div class="modal-wrapper action-modal">
      <div class="top-modal-shadow" :class="{ visible: showTopShadow }"></div>

      <div class="modal-container" ref="scrollContainer" @scroll="handleScroll">
        <slot></slot>
      </div>

      <div class="modal-actions" :class="actionsClass" :style="actionsStyle">
        <slot name="actions"></slot>
      </div>

      <div class="bottom-modal-shadow" :class="{ visible: showBottomShadow }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseModal",
  props: {
    show: { type: Boolean, required: true },
    actionsClass: { type: String, default: "" },
    actionsStyle: { type: Object, default: () => ({}) },
  },
  emits: ["close"],
  data() {
    return {
      showTopShadow: false,
      showBottomShadow: false,
    };
  },
  mounted() {
    this.checkShadow();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleScroll() {
      const el = this.$refs.scrollContainer;
      this.showTopShadow = el.scrollTop > 0;
      this.showBottomShadow = el.scrollTop + el.clientHeight < el.scrollHeight;
    },
    checkShadow() {
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer;
        if (el) {
          this.showBottomShadow = el.scrollHeight > el.clientHeight;
        }
      });
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
        this.$nextTick(() => this.checkShadow());
      } else {
        document.body.style.overflow = "";
      }
    },
  },
};
</script>

<style scoped src="../style.css"></style>
